import { get, post } from "@/config/axios"

export const notificationService = {
    getAllNotifications: (params: any) => get(`notifications-users`, { params }),
    getById: (id: string) => get(`notifications-users/${id}`),
    getCountUnreadNotifications: () => get(`notifications-users/count-unread`),
    createUserNotification: (data: any) => post(`notifications-users`, data),
    createCustomNotification: (data: any) => post(`notifications/create`, data),
}
